import React, { Component } from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

interface SelectOption {
  label: string;
  value: string;
}

interface ISelectProjectSLAGroup {
  width: string;
  onChange: (projectSLAGroup: SelectOption) => void;
  placeholder: string;
  value?: SelectOption;
  genAIOnly?: boolean;
}
export default class SelectProjectSLAGroup extends Component<ISelectProjectSLAGroup> {
  static defaultProps = {
    placeholder: 'Select a Project SLA Group',
    width: '250px',
  };

  async fetchProjectSLAGroups(search: string) {
    try {
      const query = {
        search,
        genAIOnly: this.props.genAIOnly,
      };
      const results = await apiFetch(null, `corp-api/find/projectslagroups`, { query });
      const options = results.projectSLAGroups.map((projectSLAGroup: { name: any; id: any }) => {
        return {
          label: `${projectSLAGroup.name} (${projectSLAGroup.id})`,
          value: projectSLAGroup.id,
        };
      });

      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  render() {
    const { width } = this.props;
    return (
      <div style={{ width }}>
        <Select
          {...this.props}
          loadOptions={this.fetchProjectSLAGroups.bind(this)}
          ignoreCase={true}
          placeholder="Project SLA Group Name or ID"
        />
      </div>
    );
  }
}
